import { useSearchParams } from "react-router-dom";
import { useCallback } from "react";

export default function useUrlParams(defaults = {}) {
  const [searchParams, setSearchParams] = useSearchParams();

  // Get current params with defaults
  const params = { ...defaults };
  for (let [key, value] of searchParams.entries()) {
    params[key] = value;
  }

  // Update one or multiple params
  const updateParams = useCallback(
    (newParams, reset = []) => {
      const updated = new URLSearchParams(searchParams);

      // Reset specific params (like resetting page when search changes)
      reset.forEach(key => updated.delete(key));

      Object.entries(newParams).forEach(([key, value]) => {
        if (value === undefined || value === "" || value === null) {
          updated.delete(key);
        } else {
          updated.set(key, value);
        }
      });

      setSearchParams(updated);
    },
    [searchParams, setSearchParams]
  );

  return [params, updateParams];
}
